<template>
  <form @submit.prevent="store_warehouse_transfer">
    <div class="tw-bg-white tw-border tw-border-[#E2E2E2] tw-py-8 tw-px-4 md:tw-p-8 tw-rounded-[12px]">
      <h3 class="tw-mb-5 tw-text-base tw-text-static-headerGray">اطلاعات پایه</h3>

      <div class="tw-block md:tw-grid md:tw-grid-cols-12 tw-gap-3 tw-mb-8">
        <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
          <base-select title="کارخانه"
                       placeholder="انتخاب کارخانه"
                       :float-title="true"
                       :loading="getDataLoading"
                       v-model="factory_id"
                       :options="dataStoreOrder?.factories"
                       @change="product_id = null"
                       icon="factory"/>
        </div>
        <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
          <base-select title="محصول"
                       placeholder="انتخاب محصول"
                       :float-title="true"
                       :loading="getDataLoading"
                       v-model="product_id"
                       :options="dataStoreOrder?.products?.filter(x => x.factory_id === factory_id)"
                       :show-alert="!factory_id && 'لطفا ابتدا کارخانه را انتخاب نمایید'"
                       icon="category"/>
        </div>
        <div class="tw-w-full md:tw-col-span-2 tw-mb-6">
          <base-select title="انبار مبدا"
                       placeholder="انبار مبدا را انتخاب کنید"
                       :float-title="true"
                       :loading="getDataLoading"
                       v-model="origin_warehouse_id"
                       :disabled-options="[destination_warehouse_id]"
                       :options="dataStoreOrder?.warehouses"
                       icon="warehouse"/>
        </div>
        <div class="tw-w-full md:tw-col-span-2 tw-mb-6">
          <base-select title="انبار مقصد"
                       placeholder="انبار مقصد را انتخاب کنید"
                       :float-title="true"
                       :loading="getDataLoading"
                       :disabled-options="[origin_warehouse_id]"
                       v-model="destination_warehouse_id"
                       :options="dataStoreOrder?.warehouses"
                       icon="warehouse"/>
        </div>
        <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
          <input-ayandeh
            v-model:value="tonage"
            placeholder="تن"
            icon-on-input="weight"
            float-label="میزان (تن)" />
        </div>
      </div>

      <!--    Address    -->
      <h3 class="tw-mb-5 tw-text-base tw-text-static-headerGray">آدرس</h3>
      <div class="tw-block md:tw-grid md:tw-grid-cols-12 tw-gap-3 tw-mb-5">
        <div class="tw-w-full tw-mb-6" :class="[
          users_warehouse_id === 'new' ? 'md:tw-col-span-4' : 'md:tw-col-span-8'
        ]">
          <base-select title="محل تخلیه"
                       placeholder="انتخاب محل تخلیه"
                       :search_able="true"
                       :search_in_front="false"
                       :float-title="true"
                       :loading="loadingGetCities"
                       v-model="city_id"
                       :options="cities"
                       :can-load-more="hasNextPageCities"
                       @loadMore="loadMoreCities"
                       icon="distance"/>
        </div>
        <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
          <base-select title="انبار گیرنده"
                       placeholder="انبار را انتخاب کنید"
                       :float-title="true"
                       :loading="getDataLoading"
                       v-model="users_warehouse_id"
                       :options="getAnbars"
                       icon="flag-circle" />
        </div>
        <div class="tw-w-full md:tw-col-span-4 tw-mb-6" v-show="users_warehouse_id === 'new'">
          <input-ayandeh
            ref="new_warehouse_input"
            v-model:value="new_user_warehouse_title"
            placeholder="نام انبار مبدا جدید را وارد کنید"
            icon-on-input="warehouse"
            float-label="نام انبار مبدا جدید" />
        </div>
      </div>

      <!--    Rent    -->
      <h3 class="tw-mb-5 tw-text-base tw-text-static-headerGray">کرایه</h3>
      <div class="tw-block md:tw-grid md:tw-grid-cols-12 tw-gap-3 tw-mb-5">
        <div class="tw-w-full md:tw-col-span-2 tw-mb-6">
          <input-ayandeh
            v-model:value="rent"
            :number-format="true"
            placeholder="کرایه هر تن بار"
            icon-on-input="money-bag"
            float-label="کرایه (ریال)" />
        </div>
        <div class="tw-w-full md:tw-col-span-2 tw-mb-6">
          <input-ayandeh
            v-model:value="reward"
            :number-format="true"
            placeholder="انعام هر تن بار"
            icon-on-input="money-bag"
            float-label="انعام (ریال)" />
        </div>
        <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
          <base-select title="پرداخت کرایه توسط"
                       placeholder="انتخاب کنید"
                       :float-title="true"
                       v-model="rent_by"
                       :options="rent_by_options"
                       icon="approval-delegation"/>
        </div>
        <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
          <base-select title="ترخیص توسط"
                       placeholder="انتخاب کنید"
                       :float-title="true"
                       v-model="clearance_by"
                       :options="clearance_by_options"
                       icon="shield-person"/>
        </div>
      </div>
    </div>

    <new-manage-other-snd ref="other_sanads_manage"
                          v-model="other_sanads"
                          v-model:validated="other_sanads_validated" />

    <div class="tw-fixed tw-text-primary-500 tw-bottom-0 tw-left-0 tw-w-full tw-px-4 tw-pt-6 tw-pb-5 tw-bg-white tw-flex tw-justify-between tw-border-t tw-border-static-inputBorder2 md:tw-pr-sidebar-width">
      <button type="button" class="tw-bg-white !tw-font-bold !tw-text-primary-500" @click="addOtherSnd">
        <base-icon icon="add-circle" class="tw-ml-3 tw-align-middle" />
        افزودن سند حسابداری
      </button>

      <new-btn class="tw-relative tw-px-5"
               type="submit"
               :loading="loading_store_order"
               :disabled="!other_sanads_validated || loading_store_order"
               variant="fill"
               color="primary">
        ثبت حواله انبار
      </new-btn>
    </div>
  </form>
</template>

<script setup>

import {useStore} from 'vuex'
import {onMounted, ref, nextTick, getCurrentInstance, computed, watch} from "vue";
import BaseSelect from "@/components/base/select/BaseSelect.vue";
import { priceUnits } from '@/services/more/ConstVar'
import InputAyandeh from "@/components/inputs/InputAyandeh.vue";
import { apiGetDataStoreOrder, apiStoreNewOrder }  from '@/services/orders/Orders'
import { apiGetSiteUsers }  from '@/services/users/Users'
import { apiGetCitiesDischarge }  from '@/services/city/Cities'
import BaseIcon from "@/components/base/BaseIcon.vue";
import NewBtn from "@/components/base/btn/NewBtn.vue";
import CardManageOtherSnd from "@/views/sanads_other/CardManageOtherSnd.vue";
import SelectUsers from "@/components/base/select/SelectUsers.vue";
import NewManageOtherSnd from "@/views/sanads_other/NewManageOtherSnd.vue";
import {useForm, useField} from "vee-validate";
import * as yup from 'yup'
import { useRouter } from "vue-router";


const factory_id = ref(null);
const product_id = ref(null);
const origin_warehouse_id = ref(null);
const destination_warehouse_id = ref(null);
const users_warehouse_id = ref(null);
const new_user_warehouse_title = ref('');
const tonage = ref(null);
const city_id = ref(null);
const rent = ref(null);
const reward = ref(null);
const rent_by = ref(null);
const rent_by_options = [
  { value: 'user', label: 'مشتری'},
  { value: 'ayandeh', label: 'شرکت آینده'},
]
const clearance_by = ref(null);
const clearance_by_options = [
  { value: 'user', label: 'مشتری'},
  { value: 'ayandeh', label: 'شرکت آینده'},
]
const validate_other_sanads = ref(false)
const other_sanads = ref([])
const other_sanads_manage = ref(null)


const cities = ref([])
const pageCities = ref(1)
const hasNextPageCities = ref(false)
const loadingGetCities = ref(false)
const other_sanads_validated = ref(true)
const loading_store_order = ref(false)

const { proxy } = getCurrentInstance()
const router = useRouter()
const store = useStore()

onMounted(() => {
  getCities()
})


const props = defineProps({
  getDataLoading: {
    type: Boolean,
    default: false
  },
  dataStoreOrder: {
    type: Object,
    default: () => {}
  }
})

async function getCities(search = '') {
  loadingGetCities.value = true
  try {
    const response = await apiGetCitiesDischarge({
      search: search,
      page: pageCities.value
    })

    if(!response) return
    if(pageCities.value === 1) {
      cities.value = response?.data?.cities?.data
    } else {
      cities.value = [...cities.value, ...response?.data?.cities?.data]
    }
    hasNextPageCities.value = pageCities.value < response?.data?.cities?.last_page

  } catch (error) {
    console.log(error)
  } finally {
    loadingGetCities.value = false
  }
}



function loadMoreCities(arg) {
  if(arg?.page) {
    pageCities.value = arg.page
  } else {
    pageCities.value++
  }

  if(pageCities.value === 1) {
    cities.value = []
  }
  getCities(arg?.search || '')
}


async  function addOtherSnd() {
  await nextTick()
  other_sanads_manage.value.add_sanad()
}

const { handleSubmit, errors } = useForm({
  validationSchema: {
    factory_id: yup.string().required('کارخانه الزامی است'),
    product_id: yup.string().required('محصول الزامی است'),
    origin_warehouse_id: yup.string().required('انبار مبدا الزامی است'),
    tonage: yup.string().required('میزان خرید الزامی است'),
    city_id: yup.string().required('محل تخلیه الزامی است'),
    users_warehouse_id: yup.string().required('انبار گیرنده الزامی است'),
    rent: yup.string().required('کرایه الزامی است'),
    reward: yup.string().nullable(),
    rent_by: yup.string().required('انتخاب پرداخت کننده کرایه الزامی است'),
    clearance_by: yup.string().required('انتخاب ترخیص کار الزامی است'),
  },
})


async function store_warehouse_transfer() {
  loading_store_order.value = true
  var data = {
    order_type: 'warehouse_transfer',
    tonage: tonage.value,
    product_id: product_id.value,
    city_id: city_id.value,
    users_warehouse_id: users_warehouse_id.value,
    new_user_warehouse_title: new_user_warehouse_title.value,
    origin_warehouse_id: origin_warehouse_id.value,
    destination_warehouse_id: destination_warehouse_id.value,
    rent: rent.value,
    reward: reward.value,
    rent_by: rent_by.value,
    clearance_by: clearance_by.value,
    other_sanads: other_sanads.value.map(function(item) {
      const newItem = { ...item }
      newItem.bank_information_id = item.bank_information?.id
      delete newItem.bank_information

      return newItem
    }),
  }

  try {
    const response = await apiStoreNewOrder(data)
    if(!response) return

    if (response?.data.status === 'success') {
      router.replace('/admin/card/list')
    }
    proxy.$my_alert(response.data.message, response.data.status)

  } catch (error) {
    console.log(error)
  } finally {
    loading_store_order.value = false
  }

}


const getAnbars = computed(() => {
  return [{value: 'new', label: 'تعریف انبار جدید'}, ...(props.dataStoreOrder?.anbars || [])]
})

const new_warehouse_input = ref(null)

watch(
  () => users_warehouse_id.value,
  (val) => {
    if(val === 'new'){
      nextTick(() => {
        new_warehouse_input.value.$refs.input?.focus()
      })
    }
  }
)

</script>


<style scoped>

</style>
